import { notification } from 'amumu-ui'
import Socket from '@shared/plugins/socket'
import tabtalk from '@shared/utils/tabtalk'
import { createNotification, removeNotification, NotificationType } from '@shared/utils/notification-list'
import { HOSTS, SERVERS } from '@/constants/environment'
import { ShellMode } from '@/shell-config'

const TYPE_MKT_LIVE_CHAT_NEW_VISITOR = 'Marketing.LiveChat.VisitorOnline'
const TYPE_MKT_LIVE_CHAT_NEW_MESSAGE = 'Marketing.LiveChat.VisitorMessage'

const NOTIFICATION_CLEAR_LIVE_CHAT_MESSAGE = 'clearNewMKTLiveChatMessage'
type Info = Record<string, any>

const countSignMsg = (val: number, isDot = false) => {
  const size = isDot ? '8px' : '18px'
  return `<span
  style="
  ${
    !isDot && val > 99
      ? `font-weight: bold; font-family: -apple-system, 'Helvetica Neue', Arial, 'PingFang SC', 'Hiragino Sans GB', STHeiti, 'Microsoft YaHei', 'Microsoft JhengHei', 'Source Han Sans SC', 'Noto Sans CJK SC', 'Source Han Sans CN', 'Noto Sans SC', 'Source Han Sans TC', 'Noto Sans CJK TC', 'WenQuanYi Micro Hei', SimSun, sans-serif;`
      : ''
  }
  display: block;
  position: absolute;
  left: 39px;
  top: 15px;
  width: ${size};
  height: ${size};
  text-align: center;
  font-size: 10px;
  color: #fff;
  background: #e95b5b;
  border-radius: 9px;
  line-height: 18px;">${isDot ? '' : val > 99 ? '···' : val}</span>
`
}

type MmNotification = ReturnType<typeof notification>

const socketHandlers = {
  handleMKTLiveChatNewMessage: (() => {
    let count = 0
    const clearMessage = () => {
      removeNotification(NotificationType.newMKTLiveChatMessage)
    }
    tabtalk.$on(NOTIFICATION_CLEAR_LIVE_CHAT_MESSAGE, clearMessage)

    return ({ summaryInfo }: { summaryInfo: Info }) => {
      window.masterEvent?.$emit('update-sidebar-unread-count', 'currentSession')

      const { preview_text, channel_id, conversation_id } = summaryInfo
      count++
      if (location.pathname.startsWith('/talk/live-chat')) {
        return
      }
      createNotification(NotificationType.newMKTLiveChatMessage, {
        title: '您有新的网站会话消息',
        message: `${countSignMsg(count)}${preview_text}`,
        iconEntity: `<i style="font-size: 34px; margin-right: 14px; color: #0064ff; line-height: 1.2;"
        class="common-iconfont common-iconfont-message-icon"/>`,
        onClick: (vm: MmNotification) => {
          window.open(`${HOSTS.MKT}/talk/live-chat?conversation_id=${conversation_id}&channel_id=${channel_id}`)
          count = 0
          vm.close()
        },
      })
    }
  })(),
  handleMKTLiveChatNewVisitor: (() => {
    let count = 0
    const clearMessage = () => {
      removeNotification(NotificationType.newMKTLiveChatVisitor)
    }
    tabtalk.$on(NOTIFICATION_CLEAR_LIVE_CHAT_MESSAGE, clearMessage)
    return ({ summaryInfo }: { summaryInfo: Info }) => {
      const { channel_id, conversation_id } = summaryInfo
      count++
      if (location.pathname.startsWith('/talk/live-chat')) {
        return
      }
      createNotification(NotificationType.newMKTLiveChatVisitor, {
        title: '您的网站有新访客',
        message: `${countSignMsg(count)}点击查看`,
        iconEntity: `<i style="font-size: 34px; margin-right: 14px; color: #0064ff; line-height: 1.2;"
        class="common-iconfont common-iconfont-message-icon"/>`,
        onClick: (vm: MmNotification) => {
          window.open(`${HOSTS.MKT}/talk/live-chat?conversation_id=${conversation_id}&channel_id=${channel_id}`)
          count = 0
          vm.close()
        },
      })
    }
  })(),
}

export default function bootstrapSocket(shellMode: ShellMode, getSocket?: Function) {
  const socket = getSocket ? getSocket() : new Socket(SERVERS.SOCKET)

  socket
    // MKT客服新消息提醒
    .register(TYPE_MKT_LIVE_CHAT_NEW_MESSAGE, socketHandlers.handleMKTLiveChatNewMessage)
    // MKT客服新访客提醒
    .register(TYPE_MKT_LIVE_CHAT_NEW_VISITOR, socketHandlers.handleMKTLiveChatNewVisitor)
  return socket
}
